import { GlobalResponseObject } from "@gtpl/shared-models/common-models";

export class DistrictStatusWiseResponseModel extends GlobalResponseObject {
    data?: number;
    data1?: number;
    total?: number;
    active?: number;
    inActive?:number;
}